import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(root)/projects/[id]/components/ProjectDetailClient.tsx");
